<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-content class="fluid fill-height">
      <v-stepper v-model="e1" class="elevation-0 fill-height">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :editable="true" :complete="e1 > 1" step="1">Dados Pessoais</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :editable="true" step="2">Formas de Contato</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row class="align-center justify-center">
              <v-col class="col-4 ma-0 pa-0">
                <ButtonFoto
                  title="Foto de Perfil"
                  v-bind:email="email"
                  v-on:url-img="saveImgProfile"
                  folder="paciente"
                  name_img="profileImg"
                />
                <v-select
                  :items="list_language"
                  v-model="language"
                  label="Idioma"
                  @change="getLanguage"
                  solo
                  flat
                  background-color="#F7F7F7"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="align-center justify-center">
              <v-col class="col-12 col-md-12">
                <v-form v-model="valid2" ref="form2">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          label="Nome Completo"
                          v-model="name"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-select
                          :items="list_gender"
                          label="Sexo"
                          v-model="gender"
                          @change="getGender"
                          :rules="rules"
                          required
                          solo
                          flat
                          background-color="#F7F7F7"
                        ></v-select>
                        <v-text-field
                          solo
                          flat
                          label="Número de Telefone"
                          v-model="telephone"
                          :rules="rules"
                          type="tel"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <!-- <div>
                                                    <h2 class="primary--text mb-3">Endereço</h2>
                        </div>-->
                        <v-text-field
                          solo
                          flat
                          label="Nacionalidade"
                          v-model="country"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Cidade"
                          v-model="city"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelDestrito')"
                          v-model="state"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <!-- <v-select
                                                    label="Fuso horário"
                                                    :items="time_zone"
                                                    solo
                                                    flat
                                                    :rules="rules"
                                                    required
                                                    background-color="#F7F7F7"
                                                    @change="timeZone"
                        ></v-select>-->
                        <v-autocomplete
                          solo
                          flat
                          hide-no-data
                          clearable
                          label="Fuso horário"
                          v-model="time_zone_name"
                          :items="time_zone"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-btn
                        class="my-5"
                        color="secondary"
                        depressed
                        large
                        @click="e1 = 2"
                        :disabled="!valid2"
                      >CONTINUAR</v-btn>
                      <v-btn text to="profile">Cancelar</v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row class="align-center justify-center">
              <v-col class="col-12 col-md-12">
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-container>
                    <v-row class="justify-center align-end">
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          label="WhatsApp"
                          v-model="Whatsapp"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Hangouts"
                          v-model="Hangouts"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Facebook Messenger"
                          v-model="Facebook"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Skype"
                          v-model="Skype"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <div>
                          <h2 class="primary--text">Contato Emergencial</h2>
                          <p
                            class="font-italic"
                          >Só iremos contactar essa pessoa em caso de urgência.</p>
                        </div>
                        <v-text-field
                          solo
                          flat
                          label="Nome"
                          v-model="contact_name"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Email"
                          v-model="contact_email"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Telefone"
                          v-model="contact_telephone"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-btn
                        class="my-5"
                        color="secondary"
                        depressed
                        large
                        @click="submit"
                        :disabled="!valid"
                        :loading="loader"
                      >{{$t('pageEditProfile.btnSalvar')}}</v-btn>
                      <v-btn text to="profile">Cancelar</v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-content>
  </v-app>
</template>

<script>
import ButtonFoto from '@/components/ButtonFoto';
import http from '@/services/httpClient';
import moment from 'moment-timezone';

export default {
  components: {
    ButtonFoto,
  },

  data: () => ({
    valid: false,
    valid2: false,
    show2: false,
    loader: false,
    e1: 1,
    photo_profile: '',
    name: '',
    list_gender: ['Masculino', 'Feminino', 'Não Definido'],
    gender: '',
    list_language: ['pt-BR', 'pt'],
    language: '',
    fiscal_id: '',
    date_birth: '',
    country: '',
    city: '',
    state: '',
    telephone: '',
    time_zone: moment.tz.names(),
    time_offset: '',
    time_zone_name: '',
    email: '',
    contact_name: '',
    contact_telephone: '',
    contact_email: '',
    Whatsapp: '',
    Hangouts: '',
    Facebook: '',
    Skype: '',
    checkbox: false,
    rules: [v => !!v || 'Esse campo é obrigatório'],
    snackbar: false,
    msg: '',
  }),

  created() {
    this.getCod();
    this.getProfile();
  },

  computed: {
    // emailConfirmationRules() {
    //     return [
    //         (v) => !!v || 'Email é obrigatório',
    //         () => (this.email === this.check_email) || 'Email não corresponde com o informado anteriormente.',
    //         (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email está invalido'
    //     ]
    // },
    // senhaConfirmationRules() {
    //     return [
    //         (v) => !!v || 'A senha é obrigatória',
    //         () => (this.password === this.check_password) || 'A Senha não corresponde com a informada anteriormente.',
    //         (v) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$/.test(v) || 'A senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula e número.',
    //     ]
    // },
    // computedDateFormattedMomentjs () {
    //     return this.date_birth ? moment(this.date_birth).format('DD/MM/YYYY') : ''
    // },
  },

  watch: {
    time_zone_name(val) {
      if (val) {
        const m = moment().tz(val);
        this.time_offset = m.format('Z');
        this.time_zone_name = val;
      }
    },
  },

  methods: {
    stage2() {
      if (this.validaCPF(this.fiscal_id)) {
        this.e1 = 2;
        this.edit = true;
      } else {
        this.msg = 'CPF invâlido, favor adicionar um CPF válido!';
        this.snackbar = true;
      }
    },

    getLanguage(v) {
      this.language = v;
    },

    // verifyEmail() {
    //     http.post("/users/check_username/", {
    //         username: this.email
    //     })
    //     .then((response) => {
    //         console.log(response.data);
    //         // this.e1 = 2;
    //         this.msg = response.data;
    //         this.snackbar = true;
    //     })
    //     .catch((err) => {
    //         console.log(err.response.data['detail']);
    //         this.e1 = 2;
    //     })
    // },

    getGender(v) {
      this.gender = v;
    },

    async submit() {
      if (
        this.Whatsapp == ''
        && this.Hangouts == ''
        && this.Facebook == ''
        && this.Skype == ''
      ) {
        this.msg = 'Preencha ao menos um campo de contato!';
        this.snackbar = true;
      } else if (this.$refs.form.validate()) {
        this.loader = true;
        await this.editProfile();
      }
    },

    getCod() {
      this.cod = localStorage.getItem('user-id');
    },

    getProfile() {
      http
        .get(`/patients/${this.cod}/`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          this.email = response.data.email;
          this.name = response.data.name;
          this.gender = response.data.gender;
          this.language = response.data.language;
          this.country = response.data.country;
          this.city = response.data.city;
          this.state = response.data.state;
          this.telephone = response.data.telephone;
          this.Whatsapp = response.data.whatsapp;
          this.Facebook = response.data.messenger;
          this.Hangouts = response.data.hangouts;
          this.Skype = response.data.skype;
          this.contact_name = response.data.contact_name;
          this.contact_email = response.data.contact_email;
          this.contact_telephone = response.data.contact_telephone;
          this.photo_profile = response.data.photo;
          this.time_zone_name = response.data.time_zone_name;
        });
    },

    editProfile() {
      http
        .patch(
          `/patients/${this.cod}/`,
          {
            name: this.name,
            photo: this.photo_profile,
            gender: this.gender,
            language: this.language,
            country: this.country,
            city: this.city,
            state: this.state,
            telephone: this.telephone,
            whatsapp: this.Whatsapp,
            messenger: this.Facebook,
            hangouts: this.Hangouts,
            skype: this.Skype,
            contact_name: this.contact_name,
            contact_email: this.contact_email,
            contact_telephone: this.contact_telephone,
            time_zone: this.time_offset,
            time_zone_name: this.time_zone_name,
          },
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        )
        .then((response) => {
          const res = response.data;
          console.log(res);
          localStorage.setItem('user-data', JSON.stringify(res));
          this.snackbar = true;
          this.msg = 'Edição realizada com sucesso!';
          this.$router.replace('/paciente/profile');
        })
        .catch((err) => {
          console.log(err.response.data);
          if (err.response.data.email) {
            this.snackbar = true;
            this.msg = err.response.data.email;
          }
        })
        .finally(() => (this.loader = false));
    },

    gettanggal(str) {
      if (str != null) {
        return `${str.substring(8, 10)}/${str.substring(5, 7)}/${str.substring(
          0,
          4,
        )}`;
      }
      return '';
    },

    saveImgProfile(value) {
      this.photo_profile = value;
    },

    // saveDate: function(value){
    //     this.date_birth = value
    // },

    // validaCPF: function(cpf){
    //     let numeros, digitos, soma, i, resultado, digitos_iguais;
    //     digitos_iguais = 1;
    //     if (cpf.length < 11)
    //         return false;
    //     for (i = 0; i < cpf.length - 1; i++)
    //         if (cpf.charAt(i) != cpf.charAt(i + 1))
    //                 {
    //                 digitos_iguais = 0;
    //                 break;
    //                 }
    //     if (!digitos_iguais){
    //         numeros = cpf.substring(0,9);
    //         digitos = cpf.substring(9);
    //         soma = 0;
    //         for (i = 10; i > 1; i--)
    //             soma += numeros.charAt(10 - i) * i;
    //         resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    //         if (resultado != digitos.charAt(0))
    //             return false;
    //         numeros = cpf.substring(0,10);
    //         soma = 0;
    //         for (i = 11; i > 1; i--)
    //             soma += numeros.charAt(11 - i) * i;
    //         resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    //         if (resultado != digitos.charAt(1))
    //             return false;
    //         return true;
    //     }else{
    //         return false;
    //     }
    // }
  },
};
</script>
